import { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { usePhoto } from '../Photos';
import { Sheet } from '../shell/Sheet';
import { cx } from '../charte';

// Photos d'un dégât déjà signalé : vignettes, puis la photo en grand d'un toucher. La route est protégée
// (jeton en en-tête) : l'image est lue comme les photos de profil (`usePhoto`), gardée tant que la page vit.

function Thumb({ url, label, onOpen, size }: { url: string; label: string; onOpen: () => void; size: 'sm' | 'md' }) {
  const src = usePhoto(url);
  return (
    <button
      type="button"
      onClick={onOpen}
      aria-label={label}
      className={cx(
        'relative grid shrink-0 place-items-center overflow-hidden rounded-xl border border-line bg-surface-light',
        size === 'sm' ? 'h-12 w-12' : 'h-16 w-16',
      )}
    >
      {src ? <img src={src} alt="" className="h-full w-full object-cover" /> : <Loader2 size={16} className="animate-spin text-muted" aria-hidden />}
    </button>
  );
}

function Viewer({ url, title, onClose }: { url: string; title: string; onClose: () => void }) {
  const src = usePhoto(url);
  return (
    <Sheet title={title} onClose={onClose} className="sm:max-w-2xl">
      {src ? (
        <img src={src} alt={title} className="mx-auto max-h-[70dvh] w-auto rounded-xl object-contain" />
      ) : (
        <p className="py-10 text-center text-sm text-secondary">Chargement de la photo…</p>
      )}
    </Sheet>
  );
}

export function DamagePhotoStrip({ photos, title, size = 'md', max }: { photos: { id: string; url: string }[]; title: string; size?: 'sm' | 'md'; max?: number }) {
  const [open, setOpen] = useState<number | null>(null);
  const shown = max ? photos.slice(0, max) : photos;
  if (!photos.length) return null;
  return (
    <div className="flex flex-wrap items-center gap-2">
      {shown.map((photo, index) => (
        <Thumb key={photo.id} url={photo.url} size={size} label={`Voir la photo ${index + 1} : ${title}`} onOpen={() => setOpen(index)} />
      ))}
      {photos.length > shown.length && <span className="text-xs text-secondary">+{photos.length - shown.length}</span>}
      {open !== null && photos[open] && (
        <Viewer url={photos[open].url} title={`${title} · photo ${open + 1}/${photos.length}`} onClose={() => setOpen(null)} />
      )}
    </div>
  );
}
